import { css } from '@emotion/css';

import { m } from '../../motif';

export const topicStylesCss = css`
  align-items: center;
  /* Reusing --action-text-default-color since it has the color value defined by Design. This may change in the future. */
  border: ${m('--border-width-xs')} solid ${m('--action-text-default-color')};
  border-radius: ${m('--border-radius-s')};
  color: ${m('--fg-color')};
  display: flex;
  font-family: ${m('--font-family')};
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  line-height: 88%;
  padding: ${m('--spacing-xs')};
  text-align: center;
  text-decoration: none;
  text-transform: capitalize;
  white-space: nowrap;

  &:hover {
    background-color: ${m('--topic-hover-bg-color')};
  }
`;
